'use client';

import Link from 'next/link';
import Image from 'next/image';

import { Button } from '@shared/ui/components';
import ArrowIcon from '@public/icons/arrow-right.svg';
import Sphere from '@public/images/sphere.svg';
import AtomIcon from '@public/icons/atom.svg';
import SettingIcon from '@public/icons/setting.svg';
import NetIcon from '@public/icons/net.svg';
import DecisionIcon from '@public/icons/decision.svg';
import CodeBracketsEmptyIcon from '@public/icons/code-brackets-empty.svg';
import ServersIcon from '@public/icons/servers.svg';
import BagIcon from '@public/icons/bag.svg';

import styles from './WhoIsItFor.module.scss';

const targetGroups = [
  {
    icon: AtomIcon,
    title: 'University students',
    description: 'in STEM fields seeking to build quantum literacy alongside academic credits',
  },
  {
    icon: SettingIcon,
    title: 'Working Professionals & Engineers',
    description: 'eager to future-proof their skillset and explore emerging tech careers',
  },
  {
    icon: NetIcon,
    title: 'Researchers & Academics',
    description: 'aiming to integrate quantum methods into their domain expertise',
  },
  {
    icon: DecisionIcon,
    title: 'Entrepreneurs & Innovators',
    description:
      'interested in the practical applications of quantum technologies across industries',
  },
  {
    icon: CodeBracketsEmptyIcon,
    title: 'Developers & Coders',
    description: 'ready to level up with hands-on experience in quantum algorithms and tools',
  },
  {
    icon: ServersIcon,
    title: 'Enterprises',
    description: 'to empower their workforce with future-ready skills in quantum computing',
  },
  {
    icon: BagIcon,
    title: 'Governments',
    description:
      'seeking to build national capacity in quantum technologies and future-ready skills',
  },
];

export default function WhoIsItFor() {
  return (
    <div id="who-is-it-for" className={styles.container}>
      <div className={styles.whoIsItForCard}>
        <div className={styles.wrapper}>
          <div className={styles.whoIsItForCard_body}>
            <div className={styles.whoIsItForCard_body_title}>Who is it for?</div>

            <div className={styles.whoIsItForCard_body_text}>
              Q:EDU educational program is designed to transition participants of all industries and
              institutions to the next Mega Cycle in computing: Quantum.
              <br />
              Whether you are as an institution just getting your strategies to adapt, or you are an
              individual, small company, or a student, these course sequences will let you become a
              Quantum Leader.
            </div>

            <Image src={Sphere} className={styles.sphere_1} alt="Sphere" draggable={false} />
            <Image src={Sphere} className={styles.sphere_2} alt="Sphere" draggable={false} />
            <Image src={Sphere} className={styles.sphere_3} alt="Sphere" draggable={false} />
          </div>

          <Image src={Sphere} className={styles.sphere_4} alt="Sphere" draggable={false} />
        </div>

        <div className={styles.whoIsItForCard_footer}>
          <div className={styles.whoIsItForCard_footer_text}>
            If you&apos;re passionate about solving real-world problems, exploring the unknown, and
            staying ahead of the curve - Q:EDU educational program is the right fit for you.
          </div>

          <Link href="/?contact-us=true" className={styles.button}>
            <Button size="l" variant="filled">
              <div>Tell me more please</div>
              <Image src={ArrowIcon} alt="Arrow" draggable={false} />
            </Button>
          </Link>
        </div>
      </div>

      <div className={styles.targetCard}>
        <div className={styles.targetCard_title}>Who is it for</div>

        <div className={styles.targetCard_groups}>
          {targetGroups.map((group, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className={styles.group}>
              <Image src={group.icon} className={styles.group_icon} alt="icon" draggable={false} />

              <div className={styles.group_body}>
                <div className={styles.group_body_title}>{group.title}</div>
                <div className={styles.group_body_description}>{group.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
